<div class="p-1">
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header class="custom-filters-header">
      <mat-panel-title>
        <h3> {{ filterSectionTitle }} </h3>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <form [formGroup]="form" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="3% 0.5% grid"
      fxLayoutGap.lt-md="1%" class="dark-background-search-form white-mat-form-field-form w-100">
      @for (filter of filters; track filter; let i = $index) {
        <div [fxFlex]="filter.flexSize" fxFlex.lt-md="100%"
          [ngClass]="{'hide-form-field': filter.hidden}" [style.padding]="filter.padding ? '0 3% 0.5% 0' : ''">
          <!-- Simple input field -->
          @if (filter.type === FilterType.INPUT) {
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>
                {{ filter.name }}@if (filter.htmlOnlyRequired) {
                <span class="html-required">{{ 'filters.required-marker' | translate }}</span>
              }
            </mat-label>
            @if (filter.mask) {
              <input matInput [formControlName]="filter.id" [type]="filter.inputType ? filter.inputType : 'text'"
                (selectionChange)="emitTextInputChange($event, filter.id)" mask="(000) 000-0000" [maxLength]="filter.maxLength ? filter.maxLength : 50" />
            }
            @if (!filter.mask && !filter.uppercase) {
              <input matInput [formControlName]="filter.id" [type]="filter.inputType ? filter.inputType : 'text'"
                (selectionChange)="emitTextInputChange($event, filter.id)" [maxLength]="filter.maxLength ? filter.maxLength : 50" />
            }
            @if (filter.uppercase) {
              <input matInput [formControlName]="filter.id" [type]="filter.inputType ? filter.inputType : 'text'"
                (selectionChange)="emitTextInputChange($event, filter.id)" toUppercase />
            }
            @if (displayStreetFormatHint()) {
              <mat-hint>
                E.g. 111 Street Name
              </mat-hint>
            }
            @if (form.controls[filter.id].hasError('required')) {
              <mat-error>
                {{ filter.name }} <span>{{ 'filters.is-required' | translate }}</span>
              </mat-error>
            }
            @if (form.controls[filter.id].hasError('invalidEmail')) {
              <mat-error>
                Please enter a valid email address!
              </mat-error>
            }
            @if (form.controls[filter.id].hasError('invalidNickname')) {
              <mat-error>
                Nickname can contain only characters!
              </mat-error>
            }
            @if (form.controls[filter.id].hasError('invalidPhoneNumber')) {
              <mat-error>
                Please enter a valid phone number!
              </mat-error>
            }
            @if (form.controls[filter.id].hasError('invalidZipCode')) {
              <mat-error>
                Please enter a valid zip/postal code!
              </mat-error>
            }
          </mat-form-field>
        }
        @if (filter.type === FilterType.FILE) {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ filter.name }}</mat-label>
            <button mat-icon-button matPrefix (click)="f_input.click()">
              <mat-icon>attach_file</mat-icon>
            </button>
            <input type="text" readonly matInput [formControlName]="filter.id" />
            <input
              type="file"
              hidden
              #f_input
              (change)="handleFileInputChange($event.target.files, filter.id)"
              />
            @if (form.controls[filter.id].hasError('required')) {
              <mat-error>
                {{ filter.name }} <span>{{ 'filters.is-required' | translate }}</span>
              </mat-error>
            }
          </mat-form-field>
        }
        <!-- Simple date field -->
        @if (filter.type === FilterType.DATE && !filter.datePickerRange) {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ filter.name }}</mat-label>
            <input matInput [formControlName]="filter.id" [matDatepicker]="datePicker_i">
            <mat-datepicker-toggle matSuffix [for]="datePicker_i"></mat-datepicker-toggle>
            <mat-datepicker #datePicker_i></mat-datepicker>
            @if (form.controls[filter.id].hasError('matDateInvalid')) {
              <mat-error>
                Invalid {{ filter.name }} date
              </mat-error>
            }
          </mat-form-field>
        }
        <!-- Range date field -->
        @if (filter.type === FilterType.DATE && filter.datePickerRange) {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ filter.name }}</mat-label>
            <mat-date-range-input [min]="filter.minDateValue" [rangePicker]="datePicker_i">
              <input matStartDate [formControlName]="filter.id + 'Start'" [placeholder]="filter.name + ' Start'" />
              <input matEndDate [formControlName]="filter.id + 'End'" [placeholder]="filter.name + ' End'" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="datePicker_i"></mat-datepicker-toggle>
            <mat-date-range-picker #datePicker_i></mat-date-range-picker>
            @if (
              form.controls[filter.id + 'Start']?.hasError(
              'matStartDateInvalid'
              ) ||
              form.controls[filter.id + 'End']?.hasError(
              'matEndDateInvalid'
              )
              ) {
              <mat-error>Invalid {{ filter.name }} Start/End date</mat-error>
            }
            @if (form.controls[filter.id + 'Start']?.hasError(
              'matDatepickerMin'
              )) {
              <mat-error>The {{ filter.name }} Start/End Date needs to be higher or equal than {{ filter.minDateValue | date:
              'MM/dd/yyyy' }}</mat-error>
            }
          </mat-form-field>
        }
        <!-- Simple multipleselect field -->
        @if (filter.type === FilterType.SELECT) {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ filter.name }}@if (filter.htmlOnlyRequired) {
              <span class="html-required">{{ 'filters.required-marker' | translate }}</span>
            }</mat-label>
            <mat-select [formControlName]="filter.id" [multiple]="filter.multipleSelect" (selectionChange)="emitSelectionChange($event, filter.id)">
              @if (filter.selectAll) {
                <app-select-check-all [model]="form.get(filter.id)" [values]="filter.values"
                  [idField]="filter.values[0]?.value ? 'value' : null">
                </app-select-check-all>
              }
              @if (!filter.selectAll && !filter.noSelection) {
                <mat-option>No selection</mat-option>
              }
              @for (value of filter.values; track value) {
                <mat-option [value]="value?.value ? value.value : value">
                  {{ value?.display ? value.display : value }}
                </mat-option>
              }
            </mat-select>
            @if (form.controls[filter.id].hasError('required')) {
              <mat-error>
                {{ filter.name }} <span>{{ 'filters.is-required' | translate }}</span>
              </mat-error>
            }
          </mat-form-field>
        }
        @if (filter.type === FilterType.TEXTAREA) {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ filter.name }}</mat-label>
            <textarea matInput [formControlName]="filter.id"
              [maxLength]="filter.maxLength ? filter.maxLength : 50"
              (selectionChange)="emitTextInputChange($event, filter.id)"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5">
            </textarea>
          </mat-form-field>
        }
        <!-- Autocomplete field -->
        @if (filter.type === FilterType.AUTOCOMPLETE) {
          <mat-select-autocomplete [appearance]="'outline'"
            [placeholder]="filter.name" [options]="refModels.get(filter.id).options" [multiple]="filter.multipleSelect"
            [selectAll]="filter.selectAll" [name]="filter.id" ngDefaultControl [selectedOptions]="filter.defaultValues"
            [filterInput]="refModels.get(filter.id).inputSearch" [formControl]="form.controls[filter.id]"
            (selectionChange)="emitChange($event, filter.id)" (clear)="emitClear(filter.id)"
            [htmlOnlyRequired]="filter.htmlOnlyRequired" class="w-100">
          </mat-select-autocomplete>
        }
        <!-- Autocomplete Eager field -->
        @if (filter.type === FilterType.AUTOCOMPLETE_EAGER) {
          <mat-select-autocomplete
            [appearance]="'outline'"
            [placeholder]="filter.name"
            [options]="filter.values"
            [defaultValues]="filter.defaultValues"
            [multiple]='filter.multipleSelect'
            [selectAll]="filter.selectAll"
            [name]="filter.id"
            ngDefaultControl
            [disabledFlag]="form.controls[filter.id].disabled"
            [formControl]="form.controls[filter.id]"
            [htmlOnlyRequired]="filter.htmlOnlyRequired"
            (selectionChange)="emitChange($event, filter.id)"
            (clear)="emitClear(filter.id)"
            class="w-100"
            >
          </mat-select-autocomplete>
        }
      </div>
    }
    <span class="cdk-visually-hidden"></span>
  </form>
  @if (!notEditable || hasExport || customButtons?.length > 0) {
    <mat-action-row fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center"
      fxLayoutAlign.lt-md="center stretch" fxLayoutGap="2%" fxLayoutGap.lt-md="1%"
      >
      @if (!notEditable) {
        <button mat-raised-button color="primary" [fxFlex]="searchFlexSize" fxFlex.lt-md="100%"
          (click)="onSearch()" [disabled]="!(form.valid && hasChanges) || disableSearchButton"> {{ searchLabel
        }}</button>
      }
      @if (hasExport) {
        <button mat-raised-button color="primary" fxFlex="15%" fxFlex.lt-md="100%"
        (click)="onExport()">Export</button>
      }
      @for (button of customButtons; track button) {
        <button mat-raised-button color="primary" [disabled]="button.disabled" [fxFlex]="button.flexSize"
        fxFlex.lt-md="100%" (click)="doCustomAction(button)">{{ button.name }}</button>
      }
      @if (!notEditable) {
        <button mat-button fxFlex="15%" fxFlex.lt-md="100%" color="accent" (click)="clear()"
          [disabled]="!hasChanges || disableClear">
          {{ 'filters.clear' | translate }}
        </button>
      }
    </mat-action-row>
  }
</mat-expansion-panel>
</div>
